import { ticketingReducer } from "./ticketing";

import type { TicketingState, ActionTypes } from "./ticketing";

export type ActionReduxState = {
    ticketing: (state: TicketingState, action: ActionTypes) => TicketingState;
};

export type ReduxState = {
    ticketing: TicketingState;
};

export const reducers: ActionReduxState = {
    ticketing: ticketingReducer,
};
